import { UploadCloud } from 'lucide-react';
import { Button } from './Button';

interface ExportButtonProps {
  onClick?: () => void;
  // Most tables export whatever the filters left on screen, so "Exporter" says it all. Override it
  // where the scope differs and the user would otherwise have to guess — a selection, say.
  label?: string;
}

export function ExportButton(props: ExportButtonProps) {
  const { onClick, label = 'Exporter' } = props;

  return (
    <Button icon={UploadCloud} onClick={onClick} variant="outline">
      {label}
    </Button>
  );
}
